import { SectionTagTypeEnum, SectionTypeEnum } from 'common/enums/AfterSales'
import { ListDescription } from 'components'
import { Flex, Tag } from 'components/InterUI/InterUI'
import { AnalyticsTicketFlow } from 'pages/afterSales/AfterSales/AfterSales.tags'
import { useHistory } from 'react-router-dom'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import useBoundState from 'store'
import { ITicket } from 'store/afterSales/types'
import { Icons } from 'utils/icons'
import { RedemptionStatusEnum } from 'common/enums/RedemptionStatusEnum'

import { Text } from '@interco/inter-ui/components/Text'

import * as S from './TicketSection.styles'

interface IProps {
  ticketsList: ITicket[]
  sectionTag: SectionTagTypeEnum
  sectionTitle: SectionTypeEnum
}

export const TicketSection = ({ ticketsList, sectionTag, sectionTitle }: IProps) => {
  const history = useHistory()

  const contentCapitalization = useBoundState((state) => state.contentCapitalization)
  const getTicketDetails = useBoundState((state) => state.getTicketDetails)

  const chevronRight = <Icons.ChevronRight color="var(--primary500)" width={24} height={24} />
  const chooseIconLeft = (title: SectionTypeEnum) => {
    const iconProps =
      title === SectionTypeEnum.AVAILABLE
        ? {
            svgColor: 'var(--primary500)',
            bgColor: 'var(--primary100)',
          }
        : {
            svgColor: 'var(--gray500)',
            bgColor: 'var(--gray100)',
          }

    return (
      <S.IconWrap $bgColor={iconProps.bgColor}>
        <Icons.Gift color={iconProps.svgColor} width={24} height={24} />
      </S.IconWrap>
    )
  }

  if (!ticketsList || ticketsList.length === 0) return <></>

  return (
    <>
      {ticketsList.map((ticket) => {
        const { redemptionStatus } = ticket

        const redirect = (ticketId: string) => {
          AnalyticsTicketFlow(
            sectionTag,
            `${ticket.prizeAmount}`,
            ticket.luckyNumber,
            ticket.ticketAwarded ? 'você ganhou' : 'não foi dessa vez',
          )

          getTicketDetails({
            ticketId,
            history,
            pathname: TypesRoutes.AFTER_SALES_DETAILS,
          })
        }

        return (
          <ListDescription
            key={ticket.ticketId}
            margin="16px 0 0"
            iconLeft={chooseIconLeft(sectionTitle)}
            iconRight={chevronRight}
            withBorder
            onClick={() => redirect(ticket.ticketId)}
          >
            <Flex direction="column">
              <Flex direction="row" gap="8px" width="auto">
                {ticket.ticketAwarded && (
                  <S.StatusTag>
                    <Tag theme="green">Você ganhou</Tag>
                  </S.StatusTag>
                )}
                {redemptionStatus === RedemptionStatusEnum.READY_TO_RELEASE && (
                  <S.StatusTag>
                    <Tag theme="green">Resgate disponível</Tag>
                  </S.StatusTag>
                )}
                {redemptionStatus === RedemptionStatusEnum.SENT_TO_REDEMPTION && (
                  <S.StatusTag>
                    <Tag theme="yellow">Resgate em processamento</Tag>
                  </S.StatusTag>
                )}
                {redemptionStatus === RedemptionStatusEnum.REDEEMED && (
                  <S.StatusTag>
                    <Tag theme="green" intensity="light">
                      Resgatado
                    </Tag>
                  </S.StatusTag>
                )}
              </Flex>
              <Text variant="body-2" colorWeight={500} bold>
                {contentCapitalization.value1}
              </Text>
              <Text variant="body-3" colorWeight={500}>
                {`Número da sorte ${ticket.luckyNumber} `}
              </Text>
            </Flex>
          </ListDescription>
        )
      })}
    </>
  )
}
